import React from "react";
import { ContainerAllocation } from "../../../../reducers/componentSearch";
import {
  FlashPCBTable,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../../constants/Styles";

import ShipmentSummaryDetailFromIds from "../../../ShipmentSummary";
import { AllocationsTableContainer } from "./AllocationsDetailsStyles";

export default function AllocationsDetails({
  allocations,
  spentAllocations,
}: {
  allocations: ContainerAllocation[];
  spentAllocations: ContainerAllocation[];
}) {
  const TABLE_HEADER_ROW = [
    { label: "Board", width: "10rem" },
    { label: "Qty", width: "3rem" },
  ];

  if (allocations.length === 0 && spentAllocations.length === 0) {
    return null;
  }

  return (
    <AllocationsTableContainer>
      {allocations.length > 0 && (
        <>
          <>Active allocations: </>
          <FlashPCBTable>
            <thead>
              <TableHeaderRow>
                {TABLE_HEADER_ROW.map((column, index) => (
                  <TableHeaderCell key={`header-${index}`} width={column.width}>
                    {column.label}
                  </TableHeaderCell>
                ))}
              </TableHeaderRow>
            </thead>
            <tbody>
              {allocations.map((allocation, index) => (
                <TableRow key={`allocation-${index}`}>
                  <TableCell>
                    <ShipmentSummaryDetailFromIds
                      boardId={allocation.board_id}
                      shipmentId={allocation.shipment_id}
                      showBoardOwner={false}
                    />
                  </TableCell>
                  <TableCell>{allocation.quantity_allocated}</TableCell>
                </TableRow>
              ))}
            </tbody>
          </FlashPCBTable>
        </>
      )}
      {spentAllocations.length > 0 && (
        <>
          <>Spent allocations: </>
          <FlashPCBTable>
            <thead>
              <TableHeaderRow>
                {TABLE_HEADER_ROW.map((column, index) => (
                  <TableHeaderCell key={`header-${index}`} width={column.width}>
                    {column.label}
                  </TableHeaderCell>
                ))}
              </TableHeaderRow>
            </thead>
            <tbody>
              {spentAllocations.map((allocation, index) => (
                <TableRow key={`allocation-${index}`}>
                  <TableCell>
                    <ShipmentSummaryDetailFromIds
                      boardId={allocation.board_id}
                      shipmentId={allocation.shipment_id}
                      showBoardOwner={false}
                    />
                  </TableCell>
                  <TableCell>{allocation.quantity_allocated}</TableCell>
                </TableRow>
              ))}
            </tbody>
          </FlashPCBTable>
        </>
      )}
    </AllocationsTableContainer>
  );
}
